
import './App.css';
import { Route, Routes } from 'react-router';
import Layout from './Components/Layout';
import Home from './Components/Home';
import About from './Components/About';
import Contact from './Components/Contact';
import Blog from './Components/Blog';
import SuccessStories from './Elements/Stories';
import CommonQue from './Elements/CommonQue';
import HeroSection from './Elements/Herosection';
import { Carousel } from 'react-bootstrap';
import Treatment from './Components/Treatment';
import Testimonial from './Components/Testimonial';
import Counselling from './Components/Therapy/Counselling'
import Adult_Psychaitric_Cases from './Components/Therapy/Adult_Psychaitric_Cases';
import Behavorial_Therapy from './Components/Therapy/Behavorial_Therapy';
import IQ_Testing from './Components/Therapy/IQ_Testing';
import Career_Counseling from './Components/Therapy/Career_Counseling';
import Child_Guidance from './Components/Therapy/Child_Guidance';
import Marital_Therapy from './Components/Therapy/Marital_Therapy';
import Group_Therapy from './Components/Therapy/Group_Therapy';
import Psychometric_Evaluation from './Components/Therapy/Psychometric_Evaluation';
import Social_work from './Elements/Social_work';
import Videos from './Elements/Videos';
import Print_media from './Elements/Print_media';
import ScrollToTop from './Elements/ScrollToTop'
import MentalHealth from './blogintro/MentalHealthBlog';
import ManagingStress from './blogintro/ManagingStress'
import DealingWithAnxiety from './blogintro/DealingWithAnxiety'
import Mindfulness from './blogintro/Mindfulness'
import BuildingHealthyRelationships from './blogintro/BuildingHealthyRelationships'
import SelfCareMentalHealth from './blogintro/SelfCareMentalHealth'
function App() {
  return (
    <>
     <ScrollToTop />
      <Routes>

        <Route path='/' element={<Layout />} />
        {/* All routes are now wrapped by the Layout component */}
        <Route path="/" element={<Layout />}>``
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path='carousel' element={<Carousel />} />
          <Route path="Contact" element={<Contact />} />
          <Route path="Blog" element={<Blog />} />
          <Route path='Any_Questions' element={<CommonQue />} />
           <Route path='Social_work'element={<Social_work/>}/>
          <Route path='SuccessStories' element={<SuccessStories />} />
          <Route path='Herosection' element={<HeroSection />} />
          <Route path='Treatment' element={<Treatment />} />
          <Route path='Testimonial' element={<Testimonial />} />
          <Route path='Counselling' element={<Counselling />} />
          <Route path='Adult_Psychaitric_Cases' element={<Adult_Psychaitric_Cases />} />
          <Route path='Behavorial_Therapy' element={<Behavorial_Therapy/>} />
          <Route path='IQ_Testing' element={<IQ_Testing/>} />
          <Route path='Child_Guidance'element={<Child_Guidance/>} />
          <Route path='Career_Counseling'element={<Career_Counseling/>} />
          <Route path='Marital_Therapy'element={<Marital_Therapy/>}/>
          <Route path ='Group_Therapy' element={<Group_Therapy/>}/>
          <Route path='Psychometric_Evaluation'element={<Psychometric_Evaluation/>}/>
          <Route path='Videos'element={<Videos/>}/>
       
          <Route path='Print_Media'element={<Print_media/>}/>
          <Route path='MentalHealth' element={<MentalHealth />} />
          <Route path='ManagingStress'element={<ManagingStress />}/>
          <Route path='DealingWithAnxiety'element={<DealingWithAnxiety/>}/>
          <Route path='Mindfulness'element={<Mindfulness/>}/>
          <Route path='BuildingHealthyRelationships'element={<BuildingHealthyRelationships/>}/>
          <Route path='SelfCareMentalHealth'element={<SelfCareMentalHealth/>}/>
        </Route>
      </Routes>
    </>
  );
}

export default App;
